<template>
  <div>
    <div style="cursor:pointer" :class="['option', { 'selected': isSelected }]" @click="onRowSelected">
      <slot>
      </slot>
    </div>
  </div>
</template>

<script>


export default {

  props: {
    value: {},

    index: {}
  },

  inject: ['onSelected', 'optionPointer'],

  created() {

    this.$parent.$on('down', this.down);

  },

  computed: {

    isSelected() {
      return (this.optionPointer.pointer == this.index)
    }

  },


  methods: {

    onRowSelected() {

      this.onSelected()

      this.$emit('click')

    }
  }
};
</script>
<style>
.selected {

  background-color: rgba(0, 0, 0, 0.075);

}

.option {
  padding: 5px;
}
</style>
